import { Modal, ModalContent, type ModalProps } from "@/atoms-react/modal/index.react";
import { KYCIdentity } from "../kyc-identity/kyc-identity";

type ModalIdentityProps = ModalProps & {
  custom_scenario?: boolean;
  olkypassLevel?: number;
};

export const ModalKYCIdentity = ({ closable, onClose, ...props }: ModalIdentityProps) => (
  <Modal
    positionWrapperClassName={"h-full"}
    className={"m-0 h-full items-end rounded-none p-0 sm:m-0 sm:h-max sm:w-full sm:p-4 md:w-9/12"}
    maxWidthClassName={"max-w-5xl"}
    closable={closable}
    onClose={onClose}
    {...props}
  >
    <ModalContent title={""}>
      <KYCIdentity onValidated={onClose} />
    </ModalContent>
  </Modal>
);
